import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { FontSizes, FontWeights, PrimaryButton, Text } from '@calm-web/design-system';

import { useSimplifiedSignupContext } from '@/components/SimplifiedSignup/Context';
import { useAnalytics } from '@/hooks/analytics';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

import { Copy, Wrapper } from './styles';

const Error = () => {
	const { formatMessage } = useIntl();
	const routerPush = useRouterPush();
	const { error } = useSimplifiedSignupContext();
	const { logEvent } = useAnalytics();
	const [isRouting, setIsRouting] = useState(false);

	useEffect(() => {
		error?.onScreenViewed?.(logEvent);
	}, [error, logEvent]);

	if (!error) {
		return null;
	}
	const { heading, subheading, cta } = error;

	const onPress = () => {
		setIsRouting(true);
		cta?.onClick(routerPush, logEvent);
	};

	const buildHeading = () => {
		if (typeof heading === 'function') {
			const { message, placeholders = {} } = heading();
			return formatMessage(message, placeholders);
		}
		return formatMessage(heading);
	};

	const buildSubheading = () => {
		if (typeof subheading === 'function') {
			const { message, placeholders = {} } = subheading();
			return formatMessage(message, placeholders);
		}
		return formatMessage(subheading);
	};

	return (
		<Wrapper>
			<Copy>
				<Text noMargin el="h1" weight={FontWeights.Demi} size={FontSizes['2xl']}>
					{buildHeading()}
				</Text>
				<Text noMargin el="h2" weight={FontWeights.Regular} size={FontSizes.base}>
					{buildSubheading()}
				</Text>
			</Copy>
			{cta && (
				<PrimaryButton isLoading={isRouting} onPress={onPress}>
					{formatMessage(cta.label)}
				</PrimaryButton>
			)}
		</Wrapper>
	);
};

export default Error;
